import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from '../../../constants/apiConfig';
import { useSelector } from 'react-redux';
import { selectIncidentGuid } from '../../../slices/commonSelectors';
import { toast } from 'react-toastify';
import { keys } from './useCreateSafetyMessage';

export const useDeleteSafetyMessage = () => {
  const queryClient = useQueryClient();
  const incidentId = useSelector(selectIncidentGuid);

  return useMutation({
    mutationFn: async (id: string) => {
      const response = await axios.delete(
        `${config.apiGateway.ics_safety_messages}/${id}`
      );
      return response.data;
    },
    onSuccess: () => {
      if (incidentId) {
        queryClient.invalidateQueries({
          queryKey: [keys.safetyMessages, incidentId],
        });
      }
      toast.success('Safety plan deleted successfully');
    },
    onError: (error: any) => {
      const errorMessage =
        error.response?.data?.error || 'Failed to delete safety plan';
      toast.error(errorMessage);
    },
  });
};
